/**
 * @typedef {Object} EmptyObject
 */

/**
 * @typedef {Object<string, string>} Topics
 * @typedef {Object<string, Object<string, Function>>} Subscriptions
 */

class Messenger {
  constructor() {
    console.log("messenger created");

    this.logEmmitTopic = {
      log: false,
      topic: "CHECK_LIMITS",
    };

    /**
     * @type {Topics}
     * */
    this.topics = {
      CHECK_LIMITS: "CHECK_LIMITS",
      OPEN_CART: "OPEN_CART",
      BUILD_CART: "BUILD_CART",
      UPDATE_CART_BUBBLE: "UPDATE_CART_BUBBLE",
      UPDATE_TOTAL_PRICE: "UPDATE_TOTAL_PRICE",
      VARIANT_CHANGE: "VARIANT_CHANGE",
      CART_READY: "CART_READY",
      PP_LIMIT_MESSAGE_SHOW: "PP_LIMIT_MESSAGE_SHOW",
      PP_LIMIT_MESSAGE_HIDE: "PP_LIMIT_MESSAGE_HIDE",
      UPDATE_CART_ITEMS: "UPDATE_CART_ITEMS",
      RESET_PRODUCT_FORM: "RESET_PRODUCT_FORM",
      OPEN_CP_EXTENDED_OFFER_MODAL: "OPEN_CP_EXTENDED_OFFER_MODAL",
      SET_VARIANT_INPUT_ON_PRODUCT_CARD: "SET_VARIANT_INPUT_ON_PRODUCT_CARD",
      SET_STATE_ON_MOBILE_VARIANT_SELECT_CP:
        "SET_STATE_ON_MOBILE_VARIANT_SELECT_CP",
      UPDATE_DISCOUNT_BADGE: "UPDATE_DISCOUNT_BADGE",
      UPDATE_PRICE: "UPDATE_PRICE",
      PROMOCODE_CAPTURED: "PROMOCODE_CAPTURED",
      // LIMIT_REACHED: 'LIMIT_REACHED',
      // LIMIT_OK: 'LIMIT_OK',
      TEST: "TEST",
      OPEN_EXPIRED_ADD_TO_CART_MODAL: "OPEN_EXPIRED_ADD_TO_CART_MODAL",
      DOM_READY: "DOM_READY",
      HOLIDAY_SHIPPING_EXPIRED: "HOLIDAY_SHIPPING_EXPIRED",
      CHANGE_PRODUCT_CARD_IMAGE: "CHANGE_PRODUCT_CARD_IMAGE",
      LAST_PRODUCT_CARD_READY: "LAST_PRODUCT_CARD_READY",
      LINE_ITEM_ERROR: "LINE_ITEM_ERROR",
      SET_THIS_CARD_BUTTON_TO_SOLD_OUT: "SET_THIS_CARD_BUTTON_TO_SOLD_OUT",
    };

    /**
     * @type {Subscriptions}
     * */
    this.subscriptions = {};

    this.init();
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      messenger.emmit(messenger.topics.DOM_READY);
    });
  }

  /**
   * @param {string} topic
   * @param {any} [data]
   */
  emmit(topic, data) {
    // console.log('emmiting: ', topic, data);
    // console.log('logEmmitTopic: ', this.logEmmitTopic);
    if (this.logEmmitTopic.log && this.logEmmitTopic.topic === topic) {
      console.log("emmiting: ", topic, data);
    }
    // console.log('emmiting: ', topic, data);
    window.postMessage(
      {
        type: this.topics[topic],
        data: data,
      },
      "*"
    );
  }

  /**
   * @param {string} topic
   * @param {function} callback
   * @param {string} component
   */
  listen(topic, callback, component = "Not provided") {
    // console.log(`${component} listening to: `, topic);
    window.addEventListener("message", (event) => {
      if (event.data.type === messenger.topics[topic]) {
        callback(event.data.data);
      }
    });

    if (Object.keys(this.subscriptions).length === 0) {
      return;
    }

    if (!this.subscriptions[topic]) {
      this.subscriptions[topic] = {};
    }
    this.subscriptions[topic][component] = callback;

    // console.trace('new subscription created: ', topic, component);
    console.log("subscriptions: ", this.subscriptions);
  }

  /**
   * @param {string} topic
   * @param {string} component
   */
  unlisten(topic, component) {
    if (!topic || !component) {
      // console.trace(
      //   `cant unlisten, topic ${topic} or component ${component} not provided`
      // );
      return;
    }
    if (!this.subscriptions[topic] || !this.subscriptions[topic][component]) {
      // console.trace(
      //   `cant unlisten, topic ${topic} or component ${component} not found`
      // );
      // console.log("Available subscriptions: ", this.subscriptions);
      return;
    }

    // console.log(`${component} unlistening to: `, topic);
    window.removeEventListener("message", this.subscriptions[topic][component]);
    delete this.subscriptions[topic][component];
  }
}

const messenger = new Messenger();
